const STUDY_LEVEL = {
  PRE_LEVEL: 'Preuniversitario',
  OFICIO_LEVEL: 'Oficio',
  TEC_MEDIO_LEVEL: 'Técnico Medio',
  TEC_SUPERIOR_LEVEL: 'Técnico Superior',
  UNIVERSIDAD_LEVEL: 'Universitario',
};
/**
 * Enum definition.
 *
 * @type {string[]}
 */
const STUDY_LEVEL_ENUM = Object.keys(STUDY_LEVEL);

const PRE_LEVEL = STUDY_LEVEL_ENUM[0];
const OFICIO_LEVEL = STUDY_LEVEL_ENUM[1];
const TEC_MEDIO_LEVEL = STUDY_LEVEL_ENUM[2];
const TEC_SUPERIOR_LEVEL = STUDY_LEVEL_ENUM[3];
const UNIVERSIDAD_LEVEL = STUDY_LEVEL_ENUM[4];

export {
  STUDY_LEVEL_ENUM,
  STUDY_LEVEL,
  PRE_LEVEL,
  OFICIO_LEVEL,
  TEC_MEDIO_LEVEL,
  TEC_SUPERIOR_LEVEL,
  UNIVERSIDAD_LEVEL,
};
